import { createContext } from "preact"
import { useContext } from "preact/hooks"

import { fetch_blog_post_by_slug, fetch_blog_posts } from "./fetch"
import type { BlogBootstrap } from "./types"

const BlogBootstrapContext = createContext<BlogBootstrap>(null)

interface BlogBootstrapProviderProps {
  value: BlogBootstrap
  children: preact.ComponentChildren
}

export function BlogBootstrapProvider(props: BlogBootstrapProviderProps) {
  return (
    <BlogBootstrapContext.Provider value={props.value}>{props.children}</BlogBootstrapContext.Provider>
  )
}

export function useBlogBootstrap(): BlogBootstrap {
  return useContext(BlogBootstrapContext)
}

/** Used by SSR and prerender to match `Router` / static paths. */
export function parse_blog_path(urlPath: string): "index" | { slug: string } | null {
  const path = urlPath.split("?")[0].replace(/\/$/, "") || "/"
  if (path === "/blog") {
    return "index"
  }
  if (path.startsWith("/blog/")) {
    const slug = path.slice("/blog/".length)
    if (slug) {
      return { slug }
    }
  }
  return null
}

export async function loadBlogBootstrapForUrl(urlPath: string): Promise<BlogBootstrap> {
  const parsed = parse_blog_path(urlPath)
  if (parsed === "index") {
    const posts = await fetch_blog_posts()
    return { kind: "index", posts }
  }
  if (parsed?.slug) {
    const post = await fetch_blog_post_by_slug(parsed.slug)
    return { kind: "post", post }
  }
  return null
}
